import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var PublicService = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.409 6.6c0-3.6 2.899-6.6 6.597-6.6 3.7 0 6.598 3 6.598 6.6 0 3.7-2.999 6.6-6.598 6.6-3.698.1-6.597-2.9-6.597-6.6ZM22.006 2a4.694 4.694 0 0 0-4.698 4.7c0 2.6 2.1 4.7 4.698 4.7 2.6 0 4.699-2.1 4.699-4.7S24.605 2 22.007 2ZM38.9 20.8c-.1-.4-.5-.8-1-.8h-7.896c-1.4-3-4.499-5-7.998-5-3.498 0-6.597 2-8.096 5H6.113c-.6 0-1.1.6-1 1.2l5.198 22c.1.5.5.8 1 .8h21.391c.5 0 .9-.3 1-.8l5.198-22v-.4ZM22.007 17c2.399 0 4.498 1.2 5.797 3.1H16.21c1.3-1.9 3.398-3.1 5.797-3.1ZM36.7 22l-4.798 20H12.11L7.312 22h29.389Z"
  }));
});
PublicService.displayName = 'PublicService';
PublicService.defaultProps = {
  'aria-label': 'PublicService'
};
export default PublicService;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/PublicService.js
// module id = 3072
// module chunks = 11